<template>
  <div class="faq">
    <div class="faq--header">
      <h1>Frequently Asked Questions</h1>
      <ElementInput
        ref="searchInput"
        v-model="query"
        placeholder="Search"
        size="small"
        clearable
        class="faq__search"
      >
        <i
          slot="prefix"
          class="el-input__icon el-icon-search"
        />
      </ElementInput>
    </div>
    <ElementCard>
      <h2 class="faq__section-title">
        All Users
      </h2>
      <div
        v-if="query"
        class="faq__section-search-results"
      >
        <span
          v-if="filteredInternalContent.length === 1"
        >{{ filteredInternalContent.length }} answer</span>
        <span
          v-else-if="filteredInternalContent.length > 1"
        >{{ filteredInternalContent.length }} answers</span>
        <span v-else>0 answers</span>
      </div>
      <ElementCollapse class="faq__collapse">
        <ElementCollapseItem
          v-for="(item, key) in filteredInternalContent"
          :key="key"
          :name="item.title"
        >
          <template slot="title">
            <h4
              class="faq__title"
              v-html="item.title"
            />
          </template>
          <div
            class="faq__html-content"
            v-html="item.html_content"
          />
        </ElementCollapseItem>
      </ElementCollapse>
      <h2
        id="faq-vendors-section"
        class="faq__section-title"
      >
        For Vendors
      </h2>
      <div
        v-if="query"
        class="faq__section-search-results"
      >
        <span
          v-if="filteredVendorContent.length === 1"
        >{{ filteredVendorContent.length }} answer</span>
        <span
          v-else-if="filteredVendorContent.length > 1"
        >{{ filteredVendorContent.length }} answers</span>
        <span v-else>0 answers</span>
      </div>
      <ElementCollapse class="faq__collapse">
        <ElementCollapseItem
          v-for="(item, key) in filteredVendorContent"
          :key="key"
          :name="item.title"
        >
          <template slot="title">
            <h4
              class="faq__title"
              v-html="item.title"
            />
          </template>
          <div
            class="faq__html-content"
            v-html="item.html_content"
          />
        </ElementCollapseItem>
      </ElementCollapse>
      <h2
        id="faq-vendors-section"
        class="faq__section-title"
      >
        Vendor Manuals
      </h2>
      <div
        v-if="query"
        class="faq__section-search-results"
      >
        <span
          v-if="filteredVendorManuals.length === 1"
        >{{ filteredVendorManuals.length }} answer</span>
        <span
          v-else-if="filteredVendorManuals.length > 1"
        >{{ filteredVendorManuals.length }} answers</span>
        <span v-else>0 answers</span>
      </div>
      <ElementCollapse class="faq__collapse">
        <ElementCollapseItem
          v-for="(item, key) in filteredVendorManuals"
          :key="key"
          :name="item.title"
        >
          <template slot="title">
            <h4
              class="faq__title"
              v-html="item.title"
            />
          </template>
          <div
            class="faq__html-content"
            v-html="item.html_content"
          />
        </ElementCollapseItem>
      </ElementCollapse>
    </ElementCard>
  </div>
</template>

<script>
import faqData from './assets/faq.json'
import faqVendorsData from './assets/faq-vendors.json'
import faqVendorManuals from './assets/faq-vendor-manuals.json'

export default {
  name: 'Faq',

  data () {
    return {
      content: faqData.content,
      contentVendors: faqVendorsData.content,
      contentVendorManuals: faqVendorManuals.content,
      query: ''
    }
  },

  computed: {
    /**
     * @returns {Array}
     */
    filteredInternalContent () {
      return this.filterContent(this.query.trim(), this.content)
    },

    /**
     * @returns {Array}
     */
    filteredVendorContent () {
      return this.filterContent(this.query.trim(), this.contentVendors)
    },

    /**
     * @returns {Array}
     */
    filteredVendorManuals () {
      return this.filterContent(this.query.trim(), this.contentVendorManuals)
    }
  },

  methods: {
    /**
     * @param   {string} query
     * @param   {Array}  content
     *
     * @returns {Array}
     */
    filterContent (query, content) {
      if (!query) {
        return content
      }

      const filteredContent = content.filter(
        item =>
          item.title.toLowerCase().includes(query.toLowerCase()) ||
          item.html_content.toLowerCase().includes(query.toLowerCase())
      )

      const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const regex = new RegExp(`(${escapedQuery})`, 'gi')

      return filteredContent.map(item => ({
        title: item.title.replace(regex, '<mark>$1</mark>'),
        html_content: item.html_content.replace(regex, '<mark>$1</mark>')
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
$content-header-search-width: 25%;
$total-answers-font-size: 14px;
$total-answers-text-color: #909399;
$total-answers-position-top: -4px;

.faq {
  height: 100%;
}

.faq__container {
  height: 100%;
  padding: spacing(6) spacing(4);
  overflow-y: scroll;
}

.faq__container::-webkit-scrollbar {
  display: none;
}

.faq__container h2 {
  margin-bottom: spacing(2.5);
}

.faq__section-title {
  margin-bottom: 0 !important;
}

#faq-vendors-section {
  margin-top: spacing(2.5) !important;
}

.faq--header {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: spacing(2);
  padding: 0;
}

.faq__card {
  margin-bottom: spacing(4);
  padding: spacing(2);

  h1 {
    margin-bottom: spacing(1);
  }

  p {
    margin-bottom: spacing(2);
  }

  .faq__list-main {
    @include text-title-small;
  }

  .faq__list-sub {
    @include text-body;

    margin: spacing(1) 0;
    padding-left: spacing(2);
    list-style: none;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.faq__title {
  color: $blue;
  font-size: spacing(2.1);
}

.faq__html-content {
  font-size: spacing(2);
}

.faq__title .el-collapse-item__arrow {
  color: $blue;
}

.faq__search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: $content-header-search-width;
  max-width: $content-header-search-width;
  margin-left: auto;
}

.faq__section-search-results {
  position: relative;
  top: $total-answers-position-top;
  color: $total-answers-text-color;
  font-size: $total-answers-font-size;
}
</style>

<style lang="scss">
.faq__attachments-image {
  width: percentage(70);
  padding: spacing(3);
  padding-top: spacing(2);
}

.download {
  width: percentage(35);
}

.download:hover {
  cursor: pointer;
}

.faq__attachments-image img {
  width: percentage(100);
  border-radius: spacing(1/2);
  box-shadow: $shadow-default;
}

.faq__attachments-image-half img {
  width: percentage(50);
  margin-left: percentage(25);
}

.faq__html-content h2 {
  font-size: spacing(2);
}

.faq__html-content ol {
  margin: spacing(1/2) 0;
}

.faq__html-content ul {
  margin: spacing(1/2) 0;
}
</style>
